import { LOCATION_CHANGE } from 'connected-react-router'
import {
  FORM_EXECUTE_RECAPTCHA,
  FORM_SUBMIT_FAILED,
  FORM_SUBMIT_SUCCEEDED,
  SUBMIT_PASSWORD_RESET_CONFIRMATION,
  SUBMIT_PASSWORD_RESET,
  ACCEPT_INVITATION_CONFIRM,
  ACCEPT_INVITATION_CONFIRM_FAILED,
  SUBMIT_CHANGE_PASSWORD
} from '../constants/action.types'

const initialState = {
  errorCode: '',
  error: false,
  processed: false,
  disabledForm: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FORM_SUBMIT_FAILED: {
      const { error: errorCode } = action.payload || {}
      return {
        ...state,
        error: true,
        errorCode,
        disabledForm: false
      }
    }
    case ACCEPT_INVITATION_CONFIRM_FAILED: {
      return {
        ...state,
        disabledForm: false
      }
    }
    case FORM_SUBMIT_SUCCEEDED:
      return {
        error: false,
        errorCode: '',
        processed: true,
        disabledForm: false
      }
    case SUBMIT_PASSWORD_RESET_CONFIRMATION:
    case SUBMIT_PASSWORD_RESET:
    case SUBMIT_CHANGE_PASSWORD:
    case ACCEPT_INVITATION_CONFIRM:
    case FORM_EXECUTE_RECAPTCHA:
      return {
        ...state,
        disabledForm: true
      }
    case LOCATION_CHANGE:
      return initialState
    default:
      return state
  }
}
